/**
 * Format date for display
 * @param dateStr - Date string to format
 * @param includeMonth - Whether to include month in the formatted date
 * @returns Formatted date string
 */
export function formatDate(dateStr: string | undefined, includeMonth: boolean = false): string {
  if (!dateStr) return "Present";
  
  const date = new Date(dateStr);
  
  if (includeMonth) {
    return new Intl.DateTimeFormat('en-US', { 
      year: 'numeric', 
      month: 'short'
    }).format(date);
  }
  
  return date.getFullYear().toString();
}

/**
 * Initialize smooth scroll behavior for anchor links
 */
export function initSmoothScroll(): void {
  const links = document.querySelectorAll('a[href^="#"]');

  links.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      const targetId = link.getAttribute('href')?.substring(1);
      if (!targetId) return;
      
      const target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
  
  console.log('Smooth scroll to anchor links initialized');
}